module.exports = __webpack_public_path__ + "static/media/souncloud-original.9da10a14.svg";